export default __webpack_public_path__ + "static/media/Logotipo Horizontal.7f72306b.svg";